import { PerformanceEvaluationStatusEnum } from '@/types/schema';

import { getQuizPassingPercentage } from '../../../../../QuizEditor/utils';
import { QuizPlayerReviewContentProps } from './types';

type Params = Pick<QuizPlayerReviewContentProps, 'quiz' | 'quizAttempt' | 'questionAttemptById'>;

export const getQuizReviewMetrics = (params: Params) => {
  const { quiz, quizAttempt, questionAttemptById } = params;

  const contentMaxScore = quiz.maxScore;
  const totalQuestionsCount = quiz.quizQuestionsConfig.questions?.length || 0;

  const score = quizAttempt.score ?? 0;
  const timeSpent = quizAttempt.timeSpent;
  const result = quizAttempt.result;
  const maxScore = quizAttempt.maxScore ?? contentMaxScore;
  const correctAnswersCount = quizAttempt.correctAnswersCount ?? 0;
  // No backend count for this yet, so it's derived from each question's evaluationStatus.
  const partiallyCorrectAnswersCount = quiz.quizQuestionsConfig.questions.filter(
    (question) =>
      questionAttemptById[question.id]?.evaluationStatus ===
      PerformanceEvaluationStatusEnum.PartiallyCorrect,
  ).length;

  const scorePercentage = Math.floor((score / maxScore) * 100);

  return {
    scorePercentage,
    score,
    maxScore,
    totalQuestionsCount,
    timeSpent,
    result,
    correctAnswersCount,
    partiallyCorrectAnswersCount,
    passingPercentage: getQuizPassingPercentage(quiz.passingPercentage),
  };
};
